export default __webpack_public_path__ + "static/media/thumbnail.485649d5.png";